<template>
  <div class="withdraw">
    <div class="container">
      <!-- 头部 -->
      <header class="header">
        <div class="header-content">
          <div class="left" @click="changego">
            <van-icon name="arrow-left" color="#fff" size="20px" />
          </div>
          <div class="title">提现</div>
          <div class="right" @click="goToWithdrawRecord">
            <span class="record-btn">提现记录</span>
          </div>
        </div>
      </header>

      <!-- 主要内容 -->
      <div class="main-content">
        <!-- 银行卡选择 -->
        <div class="bank-select-section" v-if="bankList.length > 0">
          <div class="bank-select-wrapper" @click="toggleBankDropdown">
            <span class="bank-text">{{ selectedBankText }}</span>
            <div class="icons-wrapper">
              <span class="close-icon" @click.stop="clearBankSelection">×</span>
              <span class="dropdown-icon" :class="{ 'rotate': showBankDropdown }">▼</span>
            </div>
          </div>
          <!-- 下拉列表 -->
          <div class="bank-dropdown" v-if="showBankDropdown">
            <div 
              v-for="(bank, index) in bankList" 
              :key="index"
              class="bank-dropdown-item"
              :class="{ 'selected': selectedBankIndex === index }"
              @click="selectBank(index)"
            >
              <div class="bank-info">
                <div class="bank-name">{{ bank.acc_bank }}</div>
                <div class="bank-account">尾号：{{ bank.acc_name.slice(-4) }}</div>
              </div>
              <div class="check-icon" v-if="selectedBankIndex === index">✓</div>
            </div>
          </div>
        </div>

        <!-- 金额输入 -->
        <div class="amount-section">
          <div class="input-wrapper">
            <input 
              type="number" 
              v-model="money" 
              placeholder="请输入金额" 
              class="amount-input"
            />
            <span class="currency">元</span>
          </div>
        </div>

        <!-- 密码输入 -->
        <div class="password-section">
          <div class="input-wrapper">
            <input 
              type="password" 
              v-model="securityCode" 
              placeholder="请输入密码" 
              class="password-input"
            />
          </div>
        </div>

        <!-- 按钮区域 -->
        <div class="button-section">
          <button class="submit-btn" @click="changeSubmit">提交</button>
          <button class="add-bank-btn" @click="goToAddBank">添加银行卡</button>
        </div>

        <!-- 温馨提示 -->
        <div class="tips-section">
          <div class="tips-title">温馨提示:</div>
          <div class="tips-item">
            <span class="tips-label">账户余额</span>
            <span class="tips-value">{{ infoList.money || '0' }}</span>
          </div>
          <div class="tips-item">
            <span class="tips-label">可提余额</span>
            <span class="tips-value">{{ infoList.money || '0' }}</span>
          </div>
          <div class="tips-item">
            <span class="tips-label">提现时间</span>
            <span class="tips-value">00:00 - 23:59</span>
          </div>
          <div class="tips-item">
            <span class="tips-label">最小提现金额</span>
            <span class="tips-value">60</span>
          </div>
          <div class="tips-item">
            <span class="tips-label">每日提现次数</span>
            <span class="tips-value">19</span>
          </div>
          <div class="tips-item">
            <span class="tips-label">每日提现金额</span>
            <span class="tips-value">100000000</span>
          </div>
          <div class="tips-note">
            您已绑定3张银行卡，一共可以绑定3张银行卡。为了您的资金安全，成功提现的银行卡会自动绑定，无法删除和更改。
          </div>
        </div>
      </div>
    </div>





    <!-- 提示弹窗 -->
    <alert-pop
      :alertType="alertType"
      :Tips="TipsTxt"
      v-if="PopAlert"
      @showAletfalse="showAletfalse"
    ></alert-pop>
  </div>
</template>

<script>
import AlertPop from "@/components/alert/AlertPop.vue";
import userApi from "@/api/user";

export default {
  name: "Withdraw",
  components: {
    AlertPop,
  },
  data() {
     return {
       selectedBankIndex: 0,
       showBankDropdown: false,
       alertType: null,
       infoList: {},
       bankList: [],
       isTrue: null,
       TipsTxt: '',
       PopAlert: false,
       money: "",
       securityCode: "",
       alertTypetitle: 2,
       isWithdrawSuccess: false,
     };
   },
  computed: {
    selectedBankText() {
      if (this.bankList.length > 0 && this.selectedBankIndex >= 0 && this.selectedBankIndex < this.bankList.length) {
        const bank = this.bankList[this.selectedBankIndex];
        return `${bank.acc_bank} 尾号：${bank.acc_name.slice(-4)}`;
      }
      return "请选择银行卡";
    },
    group_id() {
      return this.$store.state.group_id;
    },
    usercrud() {
      return this.$store.state.usercrud;
    },
  },
  
  methods: {
    toggleBankDropdown() {
      this.showBankDropdown = !this.showBankDropdown;
    },
    selectBank(index) {
      this.selectedBankIndex = index;
      this.showBankDropdown = false;
    },
    clearBankSelection() {
      this.selectedBankIndex = -1;
      this.showBankDropdown = false;
    },
    goToWithdrawRecord() {
      // 跳转到提现记录页面
      this.$router.push('/WithdrawRecord');
    },
    goToAddBank() {
      this.$router.push('/addBankCard');
    },
    showAletfalse() {
      this.PopAlert = false;
      // 如果提现成功，跳转到个人中心；否则回到上一页
      if (this.isWithdrawSuccess) {
        this.$router.push('/personal');
      } else {
        this.$router.go(-1);
      }
    },
    changeSubmit() {
      
      // 检查账户余额
      if (!this.infoList || parseFloat(this.infoList.money || 0) <= 0) {
        this.$toast('账户余额不足，无法提现');
        return;
      }
      
      if (!this.bankList || this.bankList.length === 0) {
        this.$router.push({
          path: "/addBankCard",
        });
        return;
      }
      
      if (!this.isTrue) {
        this.$router.push({
          path: "/setSecurityCode",
          query: {
            isTrue: this.isTrue,
          },
        });
        return;
      }
      
      if (this.selectedBankIndex < 0) {
         this.$toast('请选择银行卡');
         return;
       }
       
      if (!this.money) {
         this.$toast('请输入提现金额');
         return;
       }
       
       if (this.money < 60) {
         this.$toast('最小提现金额为60元');
         return;
       }
       
       if (!this.securityCode) {
         this.$toast('请输入安全码');
         return;
       }
       
       this.Withdrawal();
    },
    Withdrawal() {
      // 初始化提现成功标志位
      this.isWithdrawSuccess = false;
      
      this.$toast.loading({
        message: '提现中...',
        forbidClick: true,
        duration: 0,
      });
      
      // 获取选中的银行卡完整信息
      const selectedBank = this.bankList[this.selectedBankIndex];
      
      // 确保银行卡信息完整
      if (!selectedBank || !selectedBank.acc || !selectedBank.acc_bank || !selectedBank.acc_name) {
        this.$toast.clear();
        this.$toast.fail('银行卡信息不完整，请重新选择');
        return;
      }
      
      const bankDetails = {
        acc: selectedBank.acc,
        acc_bank: selectedBank.acc_bank,
        acc_name: selectedBank.acc_name,
        mark: selectedBank.mark || ''
      };
      
      // 验证提现金额
      const withdrawAmount = parseFloat(this.money);
      if (isNaN(withdrawAmount) || withdrawAmount <= 0) {
        this.$toast.clear();
        this.$toast.fail('请输入有效的提现金额');
        return;
      }
      
      // 检查余额是否足够
      const availableBalance = parseFloat(this.infoList.money || 0);
      if (withdrawAmount > availableBalance) {
        this.$toast.clear();
        this.$toast.fail('提现金额不能超过可用余额');
        return;
      }
      
      userApi
        .withdrawAction(bankDetails, withdrawAmount, this.securityCode)
        .then((data) => {
          this.$toast.clear();
          
          // 检查返回状态
          if (data.code === 200 || data.status === 'success') {
            this.alertType = 3;
            this.TipsTxt = data.msg || '提现申请提交成功，请等待审核';
            this.PopAlert = true;
            
            // 清空表单
            this.money = '';
            this.securityCode = '';
            
            // 重新获取账户信息
            this.info();
            
            // 标记提现成功，用于在关闭弹窗后跳转
            this.isWithdrawSuccess = true;
          } else {
            this.$toast.fail(data.msg || '提现失败');
          }
        })
        .catch((err) => {
          this.$toast.clear();
          console.error('提现接口错误:', err);
          
          // 显示接口返回的错误信息
          let errorMsg = '提现失败';
          if (err.response && err.response.data) {
            errorMsg = err.response.data.msg || err.response.data.message || errorMsg;
          } else if (err.msg) {
            errorMsg = err.msg;
          } else if (err.message) {
            errorMsg = err.message;
          }
          
          this.$toast.fail(errorMsg);
        });
    },
    changego() {
      this.$router.go(-1);
    },
    info() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      
      userApi
        .withdrawInfo()
        .then((data) => {
          this.infoList = data.data;
          this.bankList = data.data.pay_list || [];
          this.$toast.clear();
        })
        .catch((err) => {
          this.$toast.clear();
          this.$toast.fail(err.msg || '加载失败');
        });
    },
  },
  created() {
    this.info();
    
    if (this.group_id != 1) {
      this.alertType = 1;
      this.PopAlert = true;
    }
    
    userApi.safetyInfo().then((data) => {
      this.isTrue = data.data.isTrue;
    });
  },
};
</script>

<style lang="less" scoped>
.withdraw {
  min-height: 100vh;
  background: #050925;
  color: #fff;
}

.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.header {
  width: 100%;
  height: 1.31333rem;
  background: #161936;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  
  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 100%;
    
    .left {
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .title {
      font-size: 18px;
      font-weight: 500;
      color: #fff;
    }
    
    .right {
      .record-btn {
        color: #fff;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
}

.main-content {
  flex: 1;
  padding: 20px;
  margin-top: 1.31333rem;
}

.bank-select-section {
  margin-bottom: 20px;
  position: relative;
  
  .bank-select-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: .26667rem 0;
    height: 1.3rem;
    border-radius: .1rem;
    border-bottom: .02667rem solid #e5e5e5;
    padding: 0 .5rem;
    font-size: 0.47rem;
    font-weight: 400;
    cursor: pointer;
    
    .bank-text {
      color: #fff;
      font-size: 0.41rem;
      flex: 1;
      text-align: left;
    }
    
    .icons-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
      
      .close-icon {
        color: #999;
        font-size: 18px;
        cursor: pointer;
        padding: 2px;
        
        &:hover {
          color: #666;
        }
      }
      
      .dropdown-icon {
        color: #999;
        font-size: 12px;
        transition: transform 0.3s;
        cursor: pointer;
        
        &.rotate {
          transform: rotate(180deg);
        }
      }
    }
  }
  
  .bank-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    z-index: 1000;
    margin-top: 5px;
    overflow: hidden;
    
    .bank-dropdown-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 7px 22px;
      // border-bottom: 1px solid #e0e0e0;
      cursor: pointer;
      transition: background-color 0.3s;
      
      &:last-child {
        border-bottom: none;
      }
      
      &:hover {
        background: #f5f5f5;
      }
      
      &.selected {
        background: #1E88E5;
        
        .bank-info .bank-name,
        .bank-info .bank-account,
        .check-icon {
          color: #fff;
        }
      }
      
      .bank-info {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 10px;
        
        .bank-name {
          color: #333;
          font-size: 16px;
          font-weight: 500;
        }
        
        .bank-account {
          color: #666;
          font-size: 16px;
          font-weight: 500;
        }
      }
      
      .check-icon {
        color: #1E88E5;
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}

.amount-section, .password-section {
  margin-bottom: 20px;
  
  .input-wrapper {
    display: flex;
    align-items: center;
    margin: .26667rem 0;
    height: 1.3rem;
    border-radius: .1rem;
    border-bottom: .02667rem solid #e5e5e5;
    padding: 0 .8rem;
    font-size: 0.41rem;
    font-weight: 400;
    
    .amount-input, .password-input {
      flex: 1;
      background: transparent;
      border: none;
      outline: none;
      color: #fff;
      // font-size: .85333rem;
      font-weight: 400;
      
      &::placeholder {
        color: #999;
      }
    }
    
    .currency {
      color: #fff;
      // font-size: .85333rem;
      margin-left: 10px;
    }
  }
}

.button-section {
  // margin: 40px 0;
  
  .submit-btn, .add-bank-btn {
    width: 100%;
    height: 50px;
    border: none;
    border-radius: 25px;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 15px;
    cursor: pointer;
    
    &:active {
      opacity: 0.8;
    }
  }
  
  .submit-btn {
    background: linear-gradient(90deg, #4A9EFF 0%, #1E88E5 100%);
    color: #fff;
  }
  
  .add-bank-btn {
    background: linear-gradient(90deg, #4A9EFF 0%, #1E88E5 100%);
    color: #fff;
  }
}

.tips-section {
  // padding: 0 20px;
  
  .tips-title {
    color: #404040;
    font-size: 20px;
    font-weight: 500;
    // margin-bottom: 15px;
    text-align: left;
  }
  
  .tips-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    
    .tips-label {
      color: #404040;
      font-size: 14px;
      width: 40%;
    }
    
    .tips-value {
      color: #333;
      font-size: 14px;
      width: 60%;
    }
  }
  
  .tips-note {
    color: #404040;
    font-size: 18px;
    line-height: 1.5;
    // margin-top: 15px;
    // padding-top: 15px;
    text-align: left;
  }
}

.bank-picker-popup {
  .bank-picker {
    background: #1a243f;
    
    .picker-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px;
      border-bottom: 1px solid #3d5179;
      
      .picker-title {
        color: #fff;
        font-size: 16px;
        font-weight: 500;
      }
    }
    
    .bank-list {
      max-height: 300px;
      overflow-y: auto;
      
      .bank-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 20px;
        border-bottom: 1px solid #3d5179;
        cursor: pointer;
        
        &:hover {
          background: #2a3450;
        }
        
        .bank-info {
          .bank-name {
            color: #fff;
            font-size: 16px;
            margin-bottom: 5px;
          }
          
          .bank-account {
            color: #a0a0a0;
            font-size: 14px;
          }
        }
      }
    }
  }
}


</style>